import Link from 'next/link';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { generateAlphabetLinks } from './helper';


export const GlossaryLinks = () => {
  const theme = useTheme();

  const startLetter = 'a';
  const endLetter = 'z';
  const baseUrl = 'https://maisretorno.com/portal/termos';

  const alphabetLinks = generateAlphabetLinks({ startLetter, endLetter, baseUrl })

  return (
    <>
      <Typography
        variant="h3"
        fontWeight={700}
      >
        Glossário
      </Typography>
      <Typography>
        Acompanhe os mais diferentes termos do mercado financeiro.
      </Typography>
      <Typography>
        Escolha uma letra e comece a navegar.
      </Typography>
      <Box mt={5}>
        {alphabetLinks.map((letter) => (
          <Button
            component="a"
            target="_blank"
            href={letter.link}
            linkComponent={Link}
            color="primary"
            sx={{
              margin: 0.5,
              '&:hover p': {
                color: theme.palette.primary.main
              }
            }}
          >
            <Typography
              fontSize='1.25rem'
              fontWeight={700}
              sx={{
                color: theme.palette.mediumNeutral.main
              }}
            >
              {letter.letter}
            </Typography>
          </Button>
        ))}
      </Box>
    </>
  )
}